<template>
  <div class="profile-page">
	  <div class="container">
      <div class="page-header color-1-100">
        <h1>
          <span>
            <template v-if="canEditRecommendedEmails || canEditOptionalEmails">
              Edit email preferences
            </template>
            <template v-else>
              Email preferences
            </template>
          </span>
        </h1>
      </div>
      <div class="admin-breadcrumbs">
        <!--<router-link class="dashboard dashboard-custom background-1-20 color-2-100" to="/">
          <span class="dashboard-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 43.858 33.521" style="enable-background:new 0 0 43.858 33.521;" xml:space="preserve">
              <path id="XMLID_20_" class="st0" d="M39.108,0c-2.619,0-4.75,2.131-4.75,4.75c0,1.221,0.476,2.325,1.236,3.167l-4.496,7.472
                c-0.334-0.075-0.679-0.121-1.035-0.121c-1.41,0-2.664,0.63-3.535,1.608l-8.142-3.478c0.01-0.128,0.039-0.25,0.039-0.381
                c0-2.619-2.131-4.75-4.75-4.75s-4.75,2.131-4.75,4.75c0,1.221,0.476,2.325,1.236,3.167l-4.742,7.881
                c-0.603-0.086-1.222-0.055-1.83,0.099c-1.23,0.311-2.266,1.082-2.916,2.171c-0.65,1.09-0.837,2.367-0.526,3.597
                c0.311,1.231,1.082,2.267,2.171,2.917c0.745,0.444,1.579,0.672,2.425,0.672c0.391,0,0.784-0.048,1.172-0.146
                c2.54-0.642,4.083-3.229,3.442-5.769c-0.213-0.843-0.655-1.584-1.255-2.183l4.663-7.748c0.295,0.058,0.598,0.092,0.91,0.092
                c1.41,0,2.664-0.63,3.535-1.608l8.142,3.478c-0.01,0.128-0.039,0.25-0.039,0.381c0,2.619,2.131,4.75,4.75,4.75s4.75-2.131,4.75-4.75
                c0-1.175-0.445-2.237-1.154-3.067l4.539-7.542c0.295,0.058,0.598,0.092,0.91,0.092c2.619,0,4.75-2.131,4.75-4.75S41.727,0,39.108,0z
                "/>
            </svg>
          </span>
          Go to Dashboard
        </router-link>-->
        <router-link class="profile profile-custom background-1-20 color-2-100"
                     :to="{name: 'profile'}">
          <span class="profile-icon color-1-100">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                 viewBox="0 0 11.096 14.417" style="enable-background:new 0 0 11.096 14.417;" xml:space="preserve">
              <circle id="XMLID_497_" class="st0" cx="5.548" cy="3.75" r="3.75"/>
              <path id="XMLID_496_" class="st0" d="M1.002,14.417c-0.619,0-1.087-0.558-0.989-1.17c0.442-2.766,2.492-4.455,5.535-4.455
                s5.093,1.69,5.535,4.455c0.098,0.611-0.37,1.17-0.989,1.17H1.002z"/>
            </svg>
          </span>
          Go to my profile
        </router-link>
      </div>
      <div class="flex-block">
        <div class="content-right-section anchors">
          <div class="sticky-anchors background-1-40-before" tabindex="-1">
            <div class="anchor-item anchor-item-custom color-1-20 data"
                 v-if="emails && emails['required']"
                 :class="[{ 'active  color-1-100': activeSection === 'requiredEmails' }]">
              <span class="anchor-item-icon color-1-40">
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                     viewBox="0 0 19.99 21" style="enable-background:new 0 0 19.99 21;" xml:space="preserve">
                  <g>
                    <path class="st0" d="M11,14H9c-2.757,0-5,2.239-5,4.996V21h12v-2.004C16,16.239,13.756,14,11,14z"/>
                    <path class="st0" d="M6.343,12.523c-1.249-1.757-1.099-4.21,0.475-5.784c1.754-1.755,4.609-1.755,6.364,0
                      c1.574,1.573,1.724,4.027,0.475,5.784c0.629,0.259,1.212,0.608,1.733,1.028c1.702-2.526,1.439-5.992-0.793-8.226
                      c-2.534-2.535-6.658-2.533-9.193,0c-2.232,2.234-2.495,5.7-0.793,8.226C5.131,13.13,5.714,12.781,6.343,12.523z"/>
                    <path class="st0" d="M3.512,14.663C2.535,13.31,2,11.697,2,9.995c0-2.137,0.832-4.146,2.343-5.657
                      c3.119-3.119,8.194-3.119,11.313,0c2.809,2.81,3.08,7.2,0.83,10.324c0.445,0.563,0.803,1.194,1.06,1.878
                      c3.406-3.923,3.254-9.886-0.476-13.617c-3.898-3.897-10.243-3.897-14.142,0C1.041,4.812,0,7.325,0,9.995
                      c0,2.434,0.872,4.729,2.452,6.546C2.709,15.858,3.067,15.226,3.512,14.663z"/>
                    <circle class="st0" cx="10" cy="9.995" r="3"/>
                  </g>
                </svg>
              </span>
              <button @click.prevent="goToPageSection('requiredEmails')">Required emails</button>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 details"
                 v-if="emails && emails['recommended']"
                 :class="[{ 'active  color-1-100': activeSection === 'recommendedEmails' }]">
              <button @click.prevent="goToPageSection('recommendedEmails')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 18" style="enable-background:new 0 0 20 18;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M18,2h-5.185C12.401,0.838,11.302,0,10,0S7.599,0.838,7.185,2H2C0.897,2,0,2.897,0,4v12
                      c0,1.103,0.897,2,2,2h16c1.103,0,2-0.897,2-2V4C20,2.897,19.103,2,18,2z M6,6c1.105,0,2,0.896,2,2s-0.895,2-2,2S4,9.104,4,8
                      S4.895,6,6,6z M3,14c0-1.841,1.159-3,3-3c1.841,0,3,1.159,3,3H3z M10,4C9.449,4,9,3.551,9,3c0-0.551,0.449-1,1-1s1,0.449,1,1
                      C11,3.551,10.551,4,10,4z M17,14h-6v-2h6V14z M17,10h-6V8h6V10z"/>
                  </svg>
                </span>
                <template v-if="canEditRecommendedEmails === false">Recommended emails</template>
                <template v-else>Edit recommended emails</template>
              </button>
            </div>
            <div class="anchor-item anchor-item-custom color-1-20 password"
                 v-if="emails && emails['optional']"
                 :class="[{ 'active  color-1-100': activeSection === 'optionalEmails' }]">
              <button @click.prevent="goToPageSection('optionalEmails')">
                <span class="anchor-item-icon color-1-40">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
                    <path id="XMLID_1_" class="st0" d="M10,0C4.477,0,0,4.477,0,10s4.477,10,10,10c5.523,0,10-4.477,10-10S15.523,0,10,0z M11.378,10.65
                      L12,15H8l0.622-4.35C7.662,10.149,7,9.157,7,8c0-1.656,1.344-3,3-3c1.656,0,3,1.344,3,3C13,9.157,12.338,10.149,11.378,10.65z"/>
                  </svg>
                </span>
                <template v-if="canEditOptionalEmails === false">Optional emails</template>
                <template v-else>Edit optional emails</template>
              </button>
            </div>
          </div>
        </div>
        <div class="content-left-section">
          <div class="content-section consent-section no-margin-top"
               v-if="emails && emails['required']"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'requiredEmails' }]"
               tabindex="-1"
               ref="requiredEmails">
            <section class="password-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">Required emails</h3>

              <template v-for="(category, index) of emails['required']">

                <div class="form-group__checkbox-block">

                  <div class="form-group form-group__checkbox">
                    <div class="form-element">
                      <input type="checkbox" class="form-control form-control__checkbox border-2-100-after"
                             :disabled="true"
                             checked="checked"
                             data-lpignore="true"
                             :class="[{'is-locked': true }]"
                             :id="'required-email-' + index.toLowerCase().replace(' ', '-')" />
                      <label :for="'required-email-' + index.toLowerCase().replace(' ', '-')"
                             class="form-label color-2-63 background-1-20-before border-1-20-before border-2-70-after">{{ index }}</label>
                    </div>
                  </div>

                  <template v-for="email of category">

                    <div class="form-group form-group__checkbox form-group__checkbox-inside">
                      <div class="form-element">
                        <input type="checkbox" class="form-control form-control__checkbox border-2-100-after"
                               :disabled="true"
                               checked="checked"
                               data-lpignore="true"
                               :class="[{'is-locked': true }]"
                               :id="'required-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']" />
                        <label :for="'required-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']"
                               class="form-label color-2-63 background-1-20-before border-1-20-before border-2-70-after">
                          {{ email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '') }}
                        </label>
                      </div>
                    </div>

                  </template>

                </div>

              </template>

            </section>
          </div>
          <div class="content-section profile-section"
               v-if="emails && emails['recommended']"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'recommendedEmails' || canEditRecommendedEmails }]"
               tabindex="-1"
               ref="recommendedEmails">
            <section class="personal-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditRecommendedEmails === false">Recommended emails</template>
                <template v-else>Edit recommended emails</template>
              </h3>
              <button v-on:click.prevent="openEditRecommendedEmails()"
                      class="edit-details edit-details-custom border-1-40 color-2-100" v-if="canEditRecommendedEmails === false">
                <span class="edit-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                      <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                    </g>
                  </svg>
                </span>
                Edit
              </button>

              <template v-for="(category, index) of emails['recommended']">

                <div class="form-group__checkbox-block">

                  <div class="form-group form-group__checkbox">
                    <div class="form-element">
                      <input type="checkbox" class="form-control form-control__checkbox border-2-100-after"
                             :disabled="!canEditRecommendedEmails"
                             :checked="allChildrenAreChecked(category)"
                             v-on:change="checkAllChildren($event, category)"
                             data-lpignore="true"
                             :class="[{'is-locked': !canEditRecommendedEmails }]"
                             :id="'recommended-email-' + index.toLowerCase().replace(' ', '-')" />
                      <label :for="'recommended-email-' + index.toLowerCase().replace(' ', '-')"
                             :class="!canEditRecommendedEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before'"
                             class="form-label color-2-63">{{ index }}</label>
                    </div>
                  </div>

                  <template v-for="email of category">

                    <div class="form-group form-group__checkbox form-group__checkbox-inside">
                      <div class="form-element">
                        <input type="checkbox" class="form-control form-control__checkbox border-2-100-after"
                               :disabled="!canEditRecommendedEmails"
                               v-model="email['checked']"
                               data-lpignore="true"
                               :class="[{'is-locked': !canEditRecommendedEmails }]"
                               :id="'recommended-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']" />
                        <label :for="'recommended-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']"
                               :class="!canEditRecommendedEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before'"
                               class="form-label color-2-63">
                          {{ email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '') }}
                        </label>
                      </div>
                    </div>

                  </template>

                </div>

              </template>

            </section>
            <div class="clearfix"></div>
            <div class="update-data update-data__details" v-if="canEditRecommendedEmails">
              <button v-on:click.prevent="closeEditRecommendedEmails()"
                      class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Discard changes</button>
              <button v-on:click.prevent="updateEmailPreferences('recommended')"
                      class="save-edit background-1-100 color-2-100 save-edit-details">Save changes</button>
            </div>
          </div>
          <div class="content-section profile-section"
               v-if="emails && emails['optional']"
               tabindex="-1"
               ref="optionalEmails"
               :class="[{ 'content-section__bordered border-1-20': activeSection === 'optionalEmails' || canEditOptionalEmails }]">
            <section class="password-info">
              <h3 class="content-section-title color-1-100 background-1-100-before">
                <template v-if="canEditOptionalEmails === false">Optional emails</template>
                <template v-else>Edit optional emails</template>
              </h3>
              <button v-on:click.prevent="openEditOptionalEmails()"
                      class="edit-password edit-password-custom border-1-40 color-2-100" v-if="canEditOptionalEmails === false">
                <span class="edit-icon color-1-100">
                  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                       viewBox="0 0 12.955 12.921" style="enable-background:new 0 0 12.955 12.921;" xml:space="preserve">
                    <g id="XMLID_1_">
                      <path id="XMLID_4_" class="st0" d="M0.068,11.559c-0.144,0.367-0.057,0.785,0.221,1.065C0.48,12.818,0.737,12.921,1,12.921
                        c0.118,0,0.237-0.021,0.353-0.064l2.651-0.997L1.086,8.943L0.068,11.559z"/>
                      <path id="XMLID_5_" class="st0" d="M12.033,0.905c-1.116-1.117-2.732-0.897-2.912-0.869C8.912,0.068,8.72,0.167,8.57,0.316
                        L4.123,4.763l0,0L1.962,6.925C1.932,6.955,1.92,6.997,1.894,7.029l4.038,4.038C5.965,11.041,6.006,11.029,6.036,11l3.323-3.323l0,0
                        l3.285-3.286c0.154-0.154,0.254-0.354,0.283-0.57C12.953,3.639,13.14,2.013,12.033,0.905z"/>
                    </g>
                  </svg>
                </span>
                Edit
              </button>

              <template v-for="(category, index) of emails['optional']">

                <div class="form-group__checkbox-block">

                  <div class="form-group form-group__checkbox">
                    <div class="form-element">
                      <input type="checkbox" class="form-control form-control__checkbox"
                             :disabled="!canEditOptionalEmails"
                             :checked="allChildrenAreChecked(category)"
                             v-on:change="checkAllChildren($event, category)"
                             data-lpignore="true"
                             :class="[{'is-locked': !canEditOptionalEmails }]"
                             :id="'optional-email-' + index.toLowerCase().replace(' ', '-')" />
                      <label :for="'optional-email-' + index.toLowerCase().replace(' ', '-')"
                             :class="!canEditOptionalEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before'"
                             class="form-label color-2-63">{{ index }}</label>
                    </div>
                  </div>

                  <template v-for="email of category">

                    <div class="form-group form-group__checkbox form-group__checkbox-inside">
                      <div class="form-element">
                        <input type="checkbox" class="form-control form-control__checkbox"
                               :disabled="!canEditOptionalEmails"
                               v-model="email['checked']"
                               data-lpignore="true"
                               :class="[{'is-locked': !canEditOptionalEmails }]"
                               :id="'optional-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']" />
                        <label :for="'optional-email-' + index.toLowerCase().replace(' ', '-') + '-' + email['value']"
                               :class="!canEditOptionalEmails ? 'background-1-20-before border-1-20-before border-2-70-after' : 'background-1-100-before border-1-100-before'"
                               class="form-label color-2-63">
                          {{ email['label'].replace(' (SA)', '').replace(' (CA)', '').replace(' (SA)', '').replace(' (Inviter)', '') }}
                        </label>
                      </div>
                    </div>

                  </template>

                </div>

              </template>

              <div class="update-data update-data__password" v-if="canEditOptionalEmails">
                <button v-on:click.prevent="closeEditOptionalEmails()"
                        class="cancel-edit background-2-7 color-2-100 cancel-edit-password">Discard changes</button>
                <button v-on:click.prevent="updateEmailPreferences('optional')"
                        class="save-edit background-1-100 color-2-100 save-edit-password">Save changes</button>
              </div>
            </section>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
	  </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'email-preferences',
  data: function () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      messageDisplay: false,
      canEditRecommendedEmails: false,
      canEditOptionalEmails: false,
      activeSection: 'requiredEmails',
      emails: null
    }
  },
  computed: {
    ...mapGetters([
      'selectedHightCont',
      'getUserRole',
      'getConfData'
    ])
  },
  methods: {
    ...mapActions([
      'clearConfAction',
      'setInformationMsg',
      'initConfAction',
      'authLogout'
    ]),
    openEditOptionalEmails: function () {
      this.canEditOptionalEmails = true
    },
    openEditRecommendedEmails: function () {
      this.canEditRecommendedEmails = true
    },
    closeEditOptionalEmails: function () {
      this.canEditOptionalEmails = false
      this.messageDisplay = false
      if (this.errors) {
        let self = this
        setTimeout(function () {
          self.errors.clean()
        }, 100)
      }
    },
    closeEditRecommendedEmails: function () {
      this.canEditRecommendedEmails = false
      this.messageDisplay = false
      if (this.errors) {
        let self = this
        setTimeout(function () {
          self.errors.clean()
        }, 100)
      }
    },
    getEmailPreferencesList () {
      this.$http.get(`${api.URLS.emailPreferences}/list`, api.headersAuthSettings).then((res) => {
        this.emails = res.body
      }).catch((err) => {
        if (err.status === 401) {
          this.authLogout()
        }
      })
    },
    allChildrenAreChecked (parent) {
      if (typeof parent !== 'object') {
        return false
      }
      return !parent.some((item) => item['checked'] === false)
    },
    checkAllChildren (event, parent) {
      if (typeof parent !== 'object') {
        return false
      }
      let target = event.target
      for (let child of parent) {
        child['checked'] = target.checked
      }
    },
    updateEmailPreferences (type) {
      if (this.disableAPI) return
      this.$validator.validateAll()
      if (this.errors.items.length) return
      if (!this.emails || (this.emails && !this.emails.hasOwnProperty(type))) {
        return
      }
      this.disableAPI = true
      this.$http.post(api.URLS.disabledEmails, this.emails[type], api.headersAuthSettings).then((res) => {
        this.disableAPI = false
        this.infMsgTitle = 'Email preferences was successfully updated.'
        this.infMsgDescription = 'Please note these actions are being logged.'
        this.infMsgClass = 'success'
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        })
        this.canEditRecommendedEmails = !this.canEditRecommendedEmails
      }).catch((err) => {
        this.disableAPI = false
        this.infMsgTitle = 'Error. We were not able to update your email preferences '
        for (let error in err.body.error.exception) {
          if (err.body.error.exception.hasOwnProperty(error)) {
            this.infMsgDescription += err.body.error.exception[error].message + ' '
          }
        }
        this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
        this.infMsgClass = 'error'
        this.setInformationMsg({
          isShown: true,
          title: this.infMsgTitle,
          text: this.infMsgDescription,
          className: this.infMsgClass
        })
      })
    },
    goToPageSection (ref) {
      let element = this.$refs[ref]
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
        setTimeout(function () {
          element.focus()
        })
      }
    },
    posY (elm) {
      let test = elm
      let top = 0
      while (test !== null && test.tagName.toLowerCase() !== 'body') {
        top += test.offsetTop
        test = test.offsetParent
      }
      return top
    },
    scrollY () {
      if (window.pageYOffset) {
        return window.pageYOffset
      }
      return Math.max(document.documentElement.scrollTop, document.body.scrollTop)
    },
    isScrolledIntoView (elem) {
      let docViewTop = this.scrollY()
      let docViewBottom = docViewTop + window.outerHeight
      let elemTop = this.posY(elem) + 300
      let elemBottom = elemTop + elem.offsetHeight
      return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop))
    },
    handleScroll () {
      let sections = this.$refs
      for (let index in sections) {
        if (sections.hasOwnProperty(index)) {
          let section = sections[index]
          if (section && this.isScrolledIntoView(section)) {
            this.activeSection = index
          }
        }
      }
    }
  },
  beforeMount () {
    document.title = 'Email preferences | Clear Assured'
  },
  created () {
    this.getEmailPreferencesList()
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style src='@/assets/scss/components/profile.scss' lang='scss' />



// WEBPACK FOOTER //
// EmailPreferences.vue?6a9713f0